import { isEqual } from 'lodash-es'
import { useTranslation } from 'react-i18next'

import { StringText } from '@/Atomic/Atoms/StringText'
import { Option } from '@/Atomic/Molecules/Inputs/Select/types'
import { SimpleSelect } from '@/Atomic/Molecules/SimpleSelect'
import { DOCUMENT_DESC_ORDER } from '@/Data/const'
import { useDocumentContext } from '@/hooks/documents/useDocumentHandler'

export const DocumentsConfigOrderSelect: React.FC = () => {
  const { t } = useTranslation()

  const { order, setOrder } = useDocumentContext()

  const options: Option[] = [
    {
      label: t('common.sort.recentFirst'),
      value: 'desc',
    },
    {
      label: t('common.sort.recentLast'),
      value: 'asc',
    },
  ]

  const currentValue = isEqual(order, DOCUMENT_DESC_ORDER) ? 'desc' : 'asc'
  const selectedOption = options.find((o) => o.value === currentValue)

  const handleChange = (newValue: Option) => {
    const val = newValue.value
    if (val === 'desc') {
      setOrder(['createdAt', 'desc'])
    } else {
      setOrder(['createdAt', 'asc'])
    }
  }

  return (
    <div className="d-flex align-items-center gap-1">
      <StringText value={t('common.sortBy')} />
      <SimpleSelect
        name="order-select"
        options={options}
        value={selectedOption}
        onChange={handleChange}
      />
    </div>
  )
}
